<!--详情-->
<template>
    <div class="base-create-container">
        <!--创建-->
        <div class="head-container">
            <div class="left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="right-head-container">书籍详情</div>
        </div>
        <div class="info-container">
            <div class="info-column-container">
                <div class="column-title">基本信息</div>
            </div>
            <div class="info-content-container">
                <el-form ref="form" :model="form" label-width="100px">
                    <el-row class="mt10">
                        <el-col :span="15">
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="书籍名称" prop="bookName">
                                        <el-input disabled v-model="form.bookName" placeholder="请输入书籍名称"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="书籍作者" prop="bookAuthor">
                                        <el-input disabled v-model="form.bookAuthor" placeholder="请输入书籍作者"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="出版时间" prop="publishTime">
                                        <el-date-picker disabled format="YYYY-MM-DD"
                                                        style="width: 100%;" v-model="form.publishTime"
                                                        type="datetime" placeholder="出版时间"
                                                        value-format="x" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="学段" prop="periodKey">
                                        <el-select disabled  v-model="form.periodKey" placeholder="请选择">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="年级" prop="gradeKey">
                                        <el-select disabled v-model="form.gradeKey" placeholder="请选择">
                                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="年级段" prop="bookGrade">
                                        <el-select disabled v-model="form.bookGrade" placeholder="请选择">
                                            <el-option v-for="item in bookGradeList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="书籍主题" prop="bookItem">
                                        <el-select disabled v-model="form.bookItem" placeholder="请选择">
                                            <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                                       :value="item.itemId" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">

                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="8">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="书籍封面" prop="bookCover">
                                        <el-upload disabled class="avatar-uploader"
                                                   :action="serviceUrl+'/businessservice/book/uploadCover'" :show-file-list="false"
                                                    :headers="{ token }">
                                            <img alt="" v-if="form.bookCover" :src="form.bookCover" class="avatar" style="position:absolute" />
                                            <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                                <Plus />
                                            </el-icon>
                                        </el-upload>
                                        <div style="color: #a9abad;width:100%;">推荐使用260*185尺寸的图片</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="书籍简介" prop="bookIntroduction">
                                <el-input disabled type="textarea" rows="5" v-model="form.bookIntroduction" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="推荐理由" prop="bookReason">
                                <el-input disabled type="textarea" rows="5" v-model="form.bookReason" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {infoBook} from "@/api/admin/book"
import TEditor from "@/components/TEditor.vue";
import {serviceUrl} from "@/utils/global";
import {listItem} from "@/api/admin/item";
import {queryDict} from "@/api/admin/public";
export default {
    name: "bookDetail",
    components: {
        TEditor
    },
    data() {
        return {
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            bookId:'',
            fileList:[],
            periodList:[],
            gradeList:[],
            itemList:[],
            bookGradeList:[],
            // 表单参数
            form: {
                bookId:'',
                bookName:'',
                bookCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/bookCover.png',
                bookItem:'',
                bookAuthor:'',
                bookIntroduction:'',
                publishTime:'',
                bookReason:'',
                periodKey:'',
                gradeKey:'',
                bookGrade:'',
            }

        };
    },
    created() {
        this.queryItemList();
    },
    mounted() {
        if (this.$route.query.bookId) {
            this.bookId = this.$route.query.bookId
            this.queryBookInfo()
            this.getQueryDict();
        }
    },
    computed: {},
    methods: {
        getQueryDict() {
            queryDict({ code: 'grade_period' }).then(res => {
                this.bookGradeList = res.data.data;
            })
        },
        queryItemList(){
            listItem({ itemType: 2 }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        queryBookInfo(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
                infoBook({ bookId: this.bookId }).then(res => {
                    if (res.data.code === 1) {
                        this.form = res.data.data;
                        this.periodList.forEach(j => {
                            if (this.form.periodKey == j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                    }else {
                        this.$message.error("操作失败")
                    }
                })
            });

        },
        backList(){
            this.$router.push({
                path: "/book",
            });
        },
    }
}
</script>

<style scoped>
.base-create-container{
    width: 100%;
    max-height: calc(100vh - 80px);
    background-color: #fff;
    overflow-y: auto!important;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 40px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 40px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: auto;
    padding: 5px 10px 10px 10px;
    box-sizing: border-box;
}
.info-content-container{
    width: 100%;
    height: auto;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #ff7f2e;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #ff7f2e;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1{
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 10px;
}
.topic-title-container2{
    width: 110px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.topic-title-container3{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.audio-info{
    margin-top: 15px;
}
</style>